// The translation seam. The Components call useTranslation(prefix).t(key).
// The app registers its own hook once at start-up (registerUseTranslation).
// Without a registration, t() returns the key, which is what Storybook shows.
export type Translator = {
	t: (key: string, ...params: string[]) => string,
};
export type UseTranslation = (prefix?: string) => Translator;

const fallback: UseTranslation = (prefix) => ({
	t: (key: string) => (prefix !== undefined && prefix !== '' ? prefix + '.' : '') + key,
});
let registered: UseTranslation = fallback;

export const registerUseTranslation = (hook: UseTranslation): void => {
	registered = hook;
};

// A hook: it calls the registered hook, so the rules of hooks hold as long as
// the registration happens before the first render, which the app does.
export const useTranslation: UseTranslation = (prefix) => registered(prefix);
